import { initPostHog } from "@/lib/posthog-client";

// PostHog browser init on page load. The init config + prod/token guards now
// live in lib/posthog-client.ts so they can't drift from the consent provider,
// which inits at runtime opt-in. initPostHog() reports ONLY from a real
// production deploy with a token present (so `bun run dev` and tokenless
// preview deploys stay dormant). Events route through the /ingest reverse
// proxy (next.config.ts) to dodge ad-blockers.
//
// The extra gate here is CONSENT: we only init on load when a current consent
// record already allows analytics. That flag rides in on window.__ENV__
// (app/layout.tsx computes it from the arb_consent cookie). On a pre-consent
// load this is false → no init, no tracker network calls before the user
// chooses. When they opt in later, the consent provider calls initPostHog()
// directly (no reload needed). See docs/architecture/cookie-consent.md.
if (window.__ENV__?.analyticsConsent) {
	initPostHog();
}
